// Pricer rounding/formatting per parameter and sign/integer rules. Data only
// (A2-1600).

import { FIELD_NAMES } from "./fields";

export const PARAMS_FRONTEND_ROUNDING_AND_FORMATTING = {
  company_value: {
    roundedTo: 3,
    formattedTo: 3,
    showMinDecimals: true,
  },
  company_percentage: {
    roundedTo: 2,
    formattedTo: 2,
    showMinDecimals: true,
  },
  strike: {
    roundedTo: 1,
    formattedTo: 1,
    showMinDecimals: true,
  },
  underlying: {
    roundedTo: 2,
    formattedTo: 2,
  },
  ratio: {
    roundedTo: 2,
    formattedTo: 2,
    showMinDecimals: true,
  },
  risk_free: {
    roundedTo: 1,
    formattedTo: 1,
    showMinDecimals: true,
  },
  premium: {
    roundedTo: 3,
    formattedTo: 3,
  },
  premium_percentage: {
    roundedTo: 2,
    formattedTo: 2,
  },
  premium_quantity: {
    roundedTo: 0,
    formattedTo: 0,
  },
  premium_delta: {
    roundedTo: 14,
    formattedTo: 2,
  },
  premium_gamma: {
    roundedTo: 14,
    formattedTo: 2,
  },
  premium_theta: {
    roundedTo: 14,
    formattedTo: 2,
  },
  premium_vega: {
    roundedTo: 14,
    formattedTo: 2,
  },
  premium_rho: {
    roundedTo: 14,
    formattedTo: 2,
  },
  premium_total_premium: {
    roundedTo: 2,
    formattedTo: 2,
  },
  premium_total_quantity: {
    roundedTo: 0,
    formattedTo: 0,
  },
  premium_delta_quantity: {
    roundedTo: 2,
    formattedTo: 2,
  },
  premium_gamma_quantity: {
    roundedTo: 2,
    formattedTo: 2,
  },
  premium_theta_currency: {
    roundedTo: 2,
    formattedTo: 2,
  },
  premium_vega_currency: {
    roundedTo: 2,
    formattedTo: 2,
  },
  premium_rho_currency: {
    roundedTo: 2,
    formattedTo: 2,
  },
  premium_breakeven: {
    roundedTo: 2,
    formattedTo: 2,
  },
};

export const ALWAYS_POSITIVE_PARAMS = [
  FIELD_NAMES.STRIKE,
  FIELD_NAMES.BID_QTY,
  FIELD_NAMES.ASK_QTY,
  FIELD_NAMES.STRIKE,
  FIELD_NAMES.UNDERLYING,
  FIELD_NAMES.RATIO,
];

export const ALWAYS_INTEGER_PARAMS = [];

export const ALWAYS_POSITIVE_LEG_AND_SUB_LEG_PARAMS = [
  FIELD_NAMES.BID,
  FIELD_NAMES.BID_PERCENTAGE,
  FIELD_NAMES.ASK,
  FIELD_NAMES.ASK_PERCENTAGE,
];
